import { Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white/70" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <span className="bg-white rounded-2xl p-1.5 shadow-[0_4px_14px_rgba(0,0,0,0.25)]">
              <img src="/logo-512.png" alt="Shonta Solutions LLC" className="h-12 w-auto" />
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed max-w-xs">
            Shared housing for adults in Central Florida — private and shared bedrooms in welcoming
            homes. Helping end homelessness, one room at a time.
          </p>
          <a
            href="mailto:shontasolutions@currently.com"
            className="mt-4 inline-flex items-center gap-2 text-sm hover:text-[#FF5A5F] transition-colors"
            data-testid="footer-email"
          >
            <Mail className="w-4 h-4 text-[#FF5A5F]" />
            shontasolutions@currently.com
          </a>
          <a
            href="tel:+15617059807"
            className="mt-2 flex items-center gap-2 text-sm hover:text-[#FF5A5F] transition-colors"
            data-testid="footer-phone"
          >
            <Phone className="w-4 h-4 text-[#FF5A5F]" />
            (561) 705-9807
          </a>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white text-sm tracking-widest uppercase">Explore</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><a href="/#what-we-do" data-testid="footer-link-what-we-do" className="hover:text-[#FF5A5F] transition-colors">What We Do</a></li>
            <li><a href="/#rooms" data-testid="footer-link-rooms" className="hover:text-[#FF5A5F] transition-colors">Available Rooms</a></li>
            <li><a href="/#work-with-us" data-testid="footer-link-work" className="hover:text-[#FF5A5F] transition-colors">Work With Us</a></li>
            <li><a href="/#contact" data-testid="footer-link-contact" className="hover:text-[#FF5A5F] transition-colors">Contact Us for Housing</a></li>
            <li><a href="/referral" data-testid="footer-link-flyer" className="hover:text-[#FF5A5F] transition-colors">Referral Flyer (Printable)</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white text-sm tracking-widest uppercase">Service Area</h4>
          <p className="mt-4 text-sm leading-relaxed">
            Serving Central Florida, including the Orlando area. Caseworkers, families, and community
            organizations are welcome to reach out about referrals.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-white/40 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Shonta Solutions LLC. All rights reserved.</span>
          <span>Shared housing in Central Florida.</span>
        </div>
      </div>
    </footer>
  );
}
